import { MediaRecorderHandler } from './MediaRecorderHandler'

export default new MediaRecorderHandler()
